import React, {useEffect, useState} from 'react';
import Input from "../Input";

interface Props {
	onChange: any,
	value: any
}

const SlowInput = React.forwardRef((props: Props, ref) => {
	const {
		onChange,
		value,
		...restProps
	} = props;

	const [localValue, setLocalValue] = useState('');
	const [isEditing, setEditing] = useState(false);

	useEffect(() => {
		if (!isEditing){
			setLocalValue(value);
		}
	}, [value, isEditing]);

	return (
		<Input
			{...restProps}
			value={isEditing ? localValue : value}
			onChange={e => setLocalValue(e.target.value)}
			onFocus={_ => setEditing(true)}
			onBlur={e => {
				onChange(e);
				setEditing(false);
			}}
			ref={ref}
		/>
	);
});

export default SlowInput;
